<template>
	<div class="page">
		<template v-if="loading">
			<v-card
				flat
				outlined
				class="wall-card"
			>
				<v-card-text>
					<v-skeleton-loader
						type="image, article, actions"
					></v-skeleton-loader>
				</v-card-text>
			</v-card>
		</template>
		<template v-else-if="post">
			<div v-if="$route.query.ref && $route.query.ref == 'notification' && $route.query.notification_id" class="mb-2">{{ $vuetify.lang.t('$vuetify.notifications.fromNotification') }}:</div>
			<post :post="post" @deleted="postDeleted"/>

			<v-btn plain to="/" color="accent" class="link pa-0"><v-icon>mdi-chevron-left</v-icon> Wszystkie posty</v-btn>
		</template>
	</div>
</template>
<script>
import Post from "@/components/wall/post/Post";
import {mapGetters} from 'vuex';
import axios from 'axios';
import NotificationMarkMixin from '@/mixins/NotificationMarkMixin';
export default {
	mixins: [NotificationMarkMixin],
	components: {
		Post,
	},
	data() {
		return {
			loading: false,
			errorCode: null
		}
	},
	watch: {
		'$route': function() {
			this.loadData();
		}
	},
	computed: {
		...mapGetters({
			post: 'wall/singlePost',
			seenPosts: 'wall/seenPosts'
		}),
	},
	methods: {
		async postDeleted() {
			this.loadData();
		},
		async sendSeenPost() {
			await axios
				.post("post-user-watched", {
					post_ids: [this.post.id],
				});
		},
		async loadData() {
			if(this.$route.params.id) {
				this.loading = true;
				let res = {};
				if(this.$route.name == 'Post') {
					res = await this.$store.dispatch('wall/getSinglePost', {
						id: this.$route.params.id
					});
				}
				else if(this.$route.name == 'Comment') {
					res = await this.$store.dispatch('wall/getSinglePostComment', {
						id: this.$route.params.id
					});
				}

				if(res.error) {
					console.log("ERRORRRRR", res.error.response)
					//this.error = res.error.response.status;
					//this.$snackbar.error({error: res.error});
					this.$throwError({
						code: res.error.response.status,
						message: "Nie znaleziono postu",
					})
				}
				else {
					await this.handleNotification();
					this.sendSeenPost();
				}

				this.loading = false;
			}
		},
	},
	beforeDestroy() {
		this.$store.commit('wall/setSinglePost', null)
	},
	async created() {
		await this.loadData();
	}
}
</script>
